import { AppContextProvider } from "./app/context/AppContext";
import PageDisplay from "./app/components/PageDisplay";

export default function App() {
  return (
    <AppContextProvider>
      <PageDisplay />
    </AppContextProvider>
  );
}
